import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Text, ListItem, Image } from './contactItem.styles';
import { Container } from '../../../theme/layout';
import { getField } from '../../../utils/cmsData';
import { SectionViewportContext } from '../../contentManager/pageSection/pageSection.component';
import { getImageSource } from '../../../utils/image';
import { getDevicePixelRatio } from '../../../theme/media';

export class ContactItem extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    icon: PropTypes.object,
    description: PropTypes.string.isRequired,
  };

  static contextType = SectionViewportContext;

  get src() {
    return getField(['file', 'url'], this.props.icon);
  }

  render() {
    const { text, description } = this.props;
    const imgUrl = getImageSource(this.src, 32 * getDevicePixelRatio());

    return (
      <ListItem>
        <Container row>
          <Image image={this.context.isActive && imgUrl} alt={description} aria-label={description} />
          <Text text={text} />
        </Container>
      </ListItem>
    );
  }
}
